import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

export const docsConfig: PageConfig[] = [
  {
    name: "docs",
    title: "Supporting Documents",
    questions: [
      {
        type: "file",
        name: "resources",
        title: `
          Please attach a copy of any resources or presentations used in your
          initiative.
        `,
        storeDataAsText: false,
        allowMultiple: true,
        maxSize: 10485760,
        waitForUpload: true,
      },
      {
        type: "file",
        name: "photos",
        title: `
          Please attach any photographs from your initiative that you would like
          to share.
        `,
        storeDataAsText: false,
        allowMultiple: true,
        maxSize: 10485760,
        waitForUpload: true,
      },
    ],
  },
  {
    name: "photoPermission",
    title: "Photo Permission",
    visibleIf: "!!{photos}",
    questions: [
      {
        name: "permission",
        type: "radiogroup",
        title: "Please choose a permission",
        choices: [
          "These photographs are for Rangitāne internal use only",
          "I am comfortable with these photographs being used in Rangitāne advertising, pānui and/or Annual Report."
        ],
        isRequired: true,
      },
    ],
  },
];
